"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MutationManager = void 0;
class MutationManager {
    constructor(changedName, deletedName) {
        this.changedNames = new Set(changedName);
        this.deletedNames = new Set(deletedName);
    }
    static fromPlain(plain) {
        const markers = new MutationManager(plain.changedNames, plain.deletedNames);
        return markers;
    }
    toPlain() {
        return { changedNames: [...this.changedNames], deletedNames: [...this.deletedNames] };
    }
    change(name) {
        this.changedNames.add(name);
        if (this.deletedNames.has(name)) {
            this.deletedNames.delete(name);
        }
    }
    rename(oldName, newName) {
        if (oldName === newName) {
            this.change(newName);
        }
        else {
            this.delete(oldName);
            this.change(newName);
        }
    }
    delete(name) {
        this.deletedNames.add(name);
        if (this.changedNames.has(name)) {
            this.changedNames.delete(name);
        }
    }
    reset() {
        this.changedNames.clear();
        this.deletedNames.clear();
    }
}
exports.MutationManager = MutationManager;
